export default __webpack_public_path__ + "static/media/blog-post-layout-02-img-04.a25d1383.jpg";